import {
    useState,
    useEffect,
    ChangeEventHandler,
    KeyboardEventHandler,
} from 'react';
import { checkEmail } from '@utils/dataCheck';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import { IState } from './IState';

const usePasswordRecovery = (onClose: ICloseEvent['onClose']) => {
    const { user, lang } = useStore();
    const key = useKeyDown();

    const initState: IState = {
        email: '',
        emailError: false,
        toConfrimPage: false,
    };
    const [state, setState] = useState(initState);

    const emailValidate = (email: string) => {
        const isEmailValid = checkEmail(email);
        if (!isEmailValid) {
            setState((prev) => ({
                ...prev,
                emailError: true,
            }));
            return false;
        } else {
            setState((prev) => ({
                ...prev,
                emailError: false,
            }));
            return true;
        }
    };
    const handleEmailChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        const email = e.target.value;
        setState((prev) => ({
            ...prev,
            email,
            emailError: false,
        }));
    };
    const handleSendClick = () => {
        user.resetNotExistError();
        user.resetServerError();
        const { email } = state;
        const isEmailValid = emailValidate(email);
        if (isEmailValid) {
            setState((prev) => ({
                ...prev,
                toConfrimPage: true,
            }));
            user.passwordRecovery(email);
        }
    };
    const handleInputClick = () => {
        user.resetNotExistError();
        user.resetServerError();
        setState((prev) => ({
            ...prev,
            emailError: false,
        }));
    };
    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleSendClick();
                break;
        }
    };
    const handleKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            handleKey(key);
        }
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            const target = e.target as HTMLElement;
            target.click();
        }
    };
    const handlers = {
        handleEmailChange,
        handleSendClick,
        handleInputClick,
        handleKeyDown,
        handleBtnKeyDown,
    };

    useEffect(() => {
        user.resetNotExistError();
        user.resetServerError();
    }, []);
    useEffect(() => {
        handleKey(key);
    }, [key]);

    return {
        store: user,
        lang,
        state,
        handlers,
    };
};

export default usePasswordRecovery;
